import { FunctionComponent } from "react";

import { Column, ColumnProps } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Skeleton } from "primereact/skeleton";

import "./TableSkeleton.scss";

interface ITableSkeletonProps {
  rows: number;
  columns: number;
}

export const TableSkeleton: FunctionComponent<ITableSkeletonProps> = (props: ITableSkeletonProps) => {
  const generateRandomArray = (min: number, size: number): number[] => {
    const totalMin = min * size;
    if (totalMin > 100) {
      throw new Error("Minimum too high for array size.");
    }

    const remaining = 100 - totalMin;

    // Generate random cut points for remaining portion
    const cuts = Array.from({ length: size - 1 }, () => Math.random());
    cuts.push(0, 1);
    cuts.sort((a, b) => a - b);

    const randomParts = cuts.slice(1).map((cut, i) => (cut - cuts[i]) * remaining);

    // Add the minimum value to each part
    return randomParts.map(val => val + min);
  };

  const rows = new Array(props.rows).fill("table-row");
  const columns: ColumnProps[] = generateRandomArray(20, props.columns).map((value, index) => ({
    field: "field-" + index,
    header: <Skeleton width="100%" height="1rem" />,
    body: <Skeleton width="100%" height="1rem" />,
    style: { width: value + "%" },
  }));

  return (
    <DataTable value={rows} width="100%" className="table-skeleton">
      {columns.map((columnProps, index) => (
        <Column key={index} {...columnProps} />
      ))}
    </DataTable>
  );
};
